"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ignore = exports.type = exports.toType = exports.toTypeList = exports.deserialize = exports.toData = exports.serialize = void 0;
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var utils_1 = require("./utils");
function serialize(object) {
    return JSON.stringify(toData(object));
}
exports.serialize = serialize;
function toData(object) {
    return fromType(mobx_1.toJS(object));
}
exports.toData = toData;
function fromType(value) {
    if (lodash_1.isArray(value)) {
        return lodash_1.map(value, fromType);
    }
    else if (lodash_1.isObjectLike(value) && value.constructor) {
        var data_1 = {};
        var proto_1 = Object.getPrototypeOf(value);
        lodash_1.chain(value)
            .omit(value.constructor.ignores || [])
            .keys()
            .each(function (key) {
            if (utils_1.isField(value, key, proto_1)) {
                data_1[key] = fromType(value[key]);
            }
        })
            .value();
        return data_1;
    }
    return value;
}
function deserialize(json, type) {
    return toType(JSON.parse(json), type);
}
exports.deserialize = deserialize;
function toTypeList(data, type) {
    return lodash_1.map(data, function (d) { return toType(d, type); });
}
exports.toTypeList = toTypeList;
function toType(data, type) {
    var instance;
    var Type;
    if (!type) {
        throw "You must give a type constructor or instance";
    }
    else if (lodash_1.isFunction(type)) {
        Type = type;
        instance = new Type();
    }
    else {
        instance = type;
        Type = type.constructor;
    }
    if (!data)
        return instance;
    lodash_1.assign(instance, lodash_1.omit(data, Type.ignores));
    if (Type.types) {
        lodash_1.each(lodash_1.keys(Type.types), function (k) {
            return (instance[k] = mobx_1.isArrayLike(instance[k])
                ? toTypeList(instance[k], Type.types[k])
                : toType(instance[k], Type.types[k]));
        });
    }
    return instance;
}
exports.toType = toType;
function type(type) {
    return function (target, propName, descriptor) {
        if (!target.constructor.types) {
            target.constructor.types = {};
        }
        target.constructor.types[propName] = type;
        return descriptor;
    };
}
exports.type = type;
function ignore(target, propName, descriptor) {
    if (!target.constructor.ignores) {
        target.constructor.ignores = [];
    }
    target.constructor.ignores.push(propName);
    return descriptor;
}
exports.ignore = ignore;
//# sourceMappingURL=serialization.js.map